import { setVis } from "../../../helpers/setVis";
import { changeObjColor } from "../../changeMaterialColor";
import { cloneObject } from "../../cloneObject";
import { hideAndRemoveInArr, showHideChildrenByNames } from "../helpers";

// Только один объект по уникальному признаку (например, side)
export function toggleSingleSceneObject({
    allObjects,
    activeArray,
    name,
    isChecked,
    filterActiveFn, // (el) => boolean, например: el.name.includes(side)
    position = {},
    userData = {},
    hideChildrenName = [],
    excludes = [],
    scale = {},
}) {
    if (typeof activeArray === "undefined") {
        console.warn("Такого массива activeArray не существует в servObj, выполнение функции было прервано");
        return;
    }
    if (activeArray.length) {
        hideAndRemoveInArr(activeArray);
    }
    let newObj = null;
    if (isChecked) {
        let obj = null;
        if (typeof allObjects === "undefined") {
            console.warn("Такого массива allObjects не существует в servObj, выполнение функции было прервано");
            return;
        }
        allObjects.forEach((el) => {
            if (el.name.includes(name) && !excludes.some((substr) => el.name.includes(substr))) {
                obj = el;
            }
        });
        if (!obj) {
            console.warn("Объект для клонирования не найден", name);
            return;
        }
        newObj = cloneObject(obj);
        Object.assign(newObj.position, position);
        Object.assign(newObj.scale, scale);

        newObj.userData = { ...newObj.userData, ...userData };
        // Object.assign(newObj.userData, userData);
        activeArray.push(newObj);
        servObj.scene.add(newObj);
        setVis(newObj, true);

        hideChildrenName.length
            ? showHideChildrenByNames(newObj, [...hideChildrenName, "hitbox"], false)
            : showHideChildrenByNames(newObj, ["hitbox"], false);

        userData.visibleChildren?.length && showHideChildrenByNames(newObj, [...userData.visibleChildren], true);

        changeObjColor(activeArray);
    }
    if (userData.verticalOnly) {
        const compareKeys = ["name"];
        const newUserData = userData;
        servObj.building._vertical_only = servObj.building._vertical_only.filter((el) => {
            // Если хотя бы один из ключей отсутствует — не удаляем элемент
            if (compareKeys.some((key) => el.userData[key] === undefined || newUserData[key] === undefined)) {
                return true;
            }
            // Если все ключи совпадают — удаляем элемент
            return !compareKeys.every((key) => {
                return el.userData[key] === newUserData[key];
            });
        });
        if (isChecked && newObj) {
            servObj.building.addVerticalObj(newObj);
            servObj.building.restoreObjectColor();
            setTimeout(() => {
                servObj.building.checkCollision();
                // !newObj.userData.isIntersect && servObj.building.coloringObject(newObj, servObj.building.blueColor);
            }, 0);
        }
        if (!isChecked) {
            setTimeout(() => {
                servObj.building.checkCollision();
            }, 100);
        }
    }
    if (userData.horizontalOnly) {
        const compareKeys = ["name"];
        const newUserData = userData;
        servObj.building._horizontal_only = servObj.building._horizontal_only.filter((el) => {
            // Если хотя бы один из ключей отсутствует — не удаляем элемент
            if (compareKeys.some((key) => el.userData[key] === undefined || newUserData[key] === undefined)) {
                return true;
            }
            // Если все ключи совпадают — удаляем элемент
            return !compareKeys.every((key) => {
                return el.userData[key] === newUserData[key];
            });
        });
        if (isChecked && newObj) {
            servObj.building.addHorizontalObj(newObj);
            servObj.building.restoreObjectColor();
            setTimeout(() => {
                servObj.building.checkCollision();
                // !newObj.userData.isIntersect && servObj.building.coloringObject(newObj, servObj.building.blueColor);
            }, 0);
        }
        if (!isChecked) {
            setTimeout(() => {
                servObj.building.checkCollision();
            }, 100);
        }
    }
}
